import { forwardRef, type InputHTMLAttributes, useState } from "react";
import { useTranslation } from "react-i18next";
import Eye from "lucide-react/dist/esm/icons/eye";
import EyeOff from "lucide-react/dist/esm/icons/eye-off";

import { Input } from "./Input";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export const PasswordInput = forwardRef<HTMLInputElement, Props>(
  (props, ref) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    return (
      <Input
        {...props}
        ref={ref}
        type={visible ? "text" : "password"}
        suffix={
          <button
            type="button"
            onClick={() => setVisible((previous) => !previous)}
            aria-label={visible ? t("Hide password") : t("Show password")}
            className="text-subdued hover:text-text flex cursor-pointer items-center transition-colors"
          >
            {visible ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        }
      />
    );
  }
);

PasswordInput.displayName = "PasswordInput";
